import React from 'react';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
import { getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import { useTruncateRicosContent } from '../../../ui/ricos-viewer/use-truncate-ricos-content';
import { ToggleTruncateButtonWUT } from '../../../ui/ricos-viewer/toggle-truncate-button-wut';
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStylesWUT()
};
export const RichTextWUT = _ref => {
  let {
    content,
    maxShownParagraphs,
    id,
    FieldLayout
  } = _ref;
  const customTheme = useRicosTheme(RICOS_THEME);
  const {
    displayedContent,
    isTruncated,
    isTruncateButtonShown,
    toggleTruncate
  } = useTruncateRicosContent(content, maxShownParagraphs);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(RicosViewer, {
    content: displayedContent,
    customTheme: customTheme
  }), isTruncateButtonShown && /*#__PURE__*/React.createElement(ToggleTruncateButtonWUT, {
    isTruncated: isTruncated,
    onClick: toggleTruncate
  }));
};
//# sourceMappingURL=rich-text-wut.js.map